import React from "react";
import { Outlet } from "react-router-dom";
import Filters from "../components/Filters";
import TableComponent from "../components/TableComponent";


const Crypto = (source) => {
  console.log(source)
  return (
    <section className={`w-[85%] h-full flex flex-col mt-16 mb-24 relative`}>

      <Filters />
      <TableComponent />
      <Outlet />
      

    </section>
  );
};

export default Crypto;
